import styled from "styled-components";

export const MarketCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
